const BreakpointSm = { value: "640px" };
const BreakpointMd = { value: "768px" };
const BreakpointLg = { value: "1024px" };
const BreakpointXl = { value: "1280px" };
const BreakpointXxl = { value: "1536px" };
const ColorBlue100 = { value: "#e0f2ff" };
const ColorBlue200 = { value: "#b5deff" };
const ColorBlue300 = { value: "#78bbfa" };
const ColorBlue400 = { value: "#3892f3" };
const ColorBlue500 = { value: "#0265dc" };
const ColorBlue600 = { value: "#004491" };
const ColorNeutral0 = { value: "#ffffff" };
const ColorNeutral10 = { value: "#fcfcfc" };
const ColorNeutral20 = { value: "#fafafa" };
const ColorNeutral30 = { value: "#f7f7f7" };
const ColorNeutral40 = { value: "#f5f5f5" };
const ColorNeutral50 = { value: "#eeeeee" };
const ColorNeutral60 = { value: "#dfe0e1" };
const ColorNeutral70 = { value: "#bcbcbd" };
const ColorNeutral80 = { value: "#949596" };
const ColorNeutral90 = { value: "#737475" };
const ColorNeutral100 = { value: "#606162" };
const ColorNeutral200 = { value: "#444445" };
const ColorNeutral300 = { value: "#2d2e31" };
const ColorNeutral400 = { value: "#141414" };
const ColorNeutral500 = { value: "#040404" };
const ColorBlueGrey100 = { value: "#eaeff2" };
const ColorBlueGrey200 = { value: "#d0d8dd" };
const ColorBlueGrey300 = { value: "#b4c1c8" };
const ColorBlueGrey400 = { value: "#8c9ca5" };
const ColorBlueGrey500 = { value: "#6a7a85" };
const ColorBlueGrey600 = { value: "#576671" };
const ColorOrange100 = { value: "#ffeccc" };
const ColorOrange200 = { value: "#fdd291" };
const ColorOrange300 = { value: "#ffa037" };
const ColorOrange400 = { value: "#e46f00" };
const ColorOrange500 = { value: "#b14c00" };
const ColorOrange600 = { value: "#7a2f00" };
const ColorYellow100 = { value: "#fff9e2" };
const ColorYellow200 = { value: "#fff0b1" };
const ColorYellow300 = { value: "#ffe278" };
const ColorYellow400 = { value: "#ffc902" };
const ColorYellow500 = { value: "#ffbe00" };
const ColorYellow600 = { value: "#de9500" };
const ColorGreen100 = { value: "#cef8e0" };
const ColorGreen200 = { value: "#89ecbc" };
const ColorGreen300 = { value: "#49cc93" };
const ColorGreen400 = { value: "#15a46e" };
const ColorGreen500 = { value: "#007a4d" };
const ColorGreen600 = { value: "#005132" };
const ColorCyan100 = { value: "#e3fcff" };
const ColorCyan200 = { value: "#b1f3fa" };
const ColorCyan300 = { value: "#13ceea" };
const ColorCyan400 = { value: "#08bfdf" };
const ColorCyan500 = { value: "#0ca5c0" };
const ColorCyan600 = { value: "#038299" };
const ColorPurple100 = { value: "#f1edff" };
const ColorPurple200 = { value: "#c1b6f2" };
const ColorPurple300 = { value: "#8772e5" };
const ColorPurple400 = { value: "#6954c0" };
const ColorPurple500 = { value: "#4f3a9e" };
const ColorPurple600 = { value: "#422799" };
const ColorRed100 = { value: "#ffece9" };
const ColorRed200 = { value: "#ffb2a0" };
const ColorRed300 = { value: "#ff745f" };
const ColorRed400 = { value: "#f94d32" };
const ColorRed500 = { value: "#e13212" };
const ColorRed600 = { value: "#bf2a00" };
const ColorMagenta100 = { value: "#fbeaf5" };
const ColorMagenta200 = { value: "#faafe2" };
const ColorMagenta300 = { value: "#d949a9" };
const ColorMagenta400 = { value: "#b52d88" };
const ColorMagenta500 = { value: "#982071" };
const ColorMagenta600 = { value: "#7d165b" };
const Duration = { value: "200ms" };
const DurationInstant = { value: "0ms" };
const DurationFast = { value: "100ms" };
const DurationSlow = { value: "300ms" };
const FontFamilyBase = { value: "'Nunito Sans', sans-serif" };
const FontFamilyDisplay = { value: "'Sofia Pro', SofiaPro, sans-serif" };
const FontLineHeightBase = { value: "1.5" };
const FontLineHeightDisplay = { value: "1.25" };
const FontWeightNormal = { value: "400" };
const FontWeightSemibold = { value: "600" };
const FontWeightBold = { value: "700" };
const FontSize100 = { value: "0.625rem" };
const FontSize200 = { value: "0.75rem" };
const FontSize300 = { value: "0.875rem" };
const FontSize400 = { value: "1rem" };
const FontSize500 = { value: "1.25rem" };
const FontSize600 = { value: "1.5rem" };
const FontSize700 = { value: "1.75rem" };
const FontSize800 = { value: "2rem" };
const FontSize900 = { value: "2.25rem" };
const Radius0 = { value: "0" };
const Radius1 = { value: "0.1875rem" };
const Radius2 = { value: "0.375rem" };
const Radius3 = { value: "0.5625rem" };
const Radius4 = { value: "0.75rem" };
const Radius5 = { value: "0.9375rem" };
const Radius6 = { value: "1.125rem" };
const Radius7 = { value: "1.3125rem" };
const Radius8 = { value: "1.5rem" };
const Size0 = { value: "0rem" };
const Size1 = { value: "0.25rem" };
const Size2 = { value: "0.5rem" };
const Size3 = { value: "0.75rem" };
const Size4 = { value: "1rem" };
const Size5 = { value: "1.25rem" };
const Size6 = { value: "1.5rem" };
const Size7 = { value: "1.75rem" };
const Size8 = { value: "2rem" };
const Size9 = { value: "2.25rem" };
const Size10 = { value: "2.5rem" };
const Size11 = { value: "2.75rem" };
const Size12 = { value: "3rem" };
const Size13 = { value: "3.25rem" };
const Size14 = { value: "3.5rem" };
const SizeQuarter = { value: "0.0625rem" };
const SizeHalf = { value: "0.125rem" };
const TransitionEase = { value: "cubic-bezier(.4, 0, .2, 1)" };
const TransitionEaseIn = { value: "cubic-bezier(.4, 0, 1, 1)" };
const TransitionEaseOut = { value: "cubic-bezier(0, 0, .4, 1)" };
const TransitionEaseInOut = { value: "cubic-bezier(.4, 0, .6, 1)" };

const primitive = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
	__proto__: null,
	BreakpointLg,
	BreakpointMd,
	BreakpointSm,
	BreakpointXl,
	BreakpointXxl,
	ColorBlue100,
	ColorBlue200,
	ColorBlue300,
	ColorBlue400,
	ColorBlue500,
	ColorBlue600,
	ColorBlueGrey100,
	ColorBlueGrey200,
	ColorBlueGrey300,
	ColorBlueGrey400,
	ColorBlueGrey500,
	ColorBlueGrey600,
	ColorCyan100,
	ColorCyan200,
	ColorCyan300,
	ColorCyan400,
	ColorCyan500,
	ColorCyan600,
	ColorGreen100,
	ColorGreen200,
	ColorGreen300,
	ColorGreen400,
	ColorGreen500,
	ColorGreen600,
	ColorMagenta100,
	ColorMagenta200,
	ColorMagenta300,
	ColorMagenta400,
	ColorMagenta500,
	ColorMagenta600,
	ColorNeutral0,
	ColorNeutral10,
	ColorNeutral100,
	ColorNeutral20,
	ColorNeutral200,
	ColorNeutral30,
	ColorNeutral300,
	ColorNeutral40,
	ColorNeutral400,
	ColorNeutral50,
	ColorNeutral500,
	ColorNeutral60,
	ColorNeutral70,
	ColorNeutral80,
	ColorNeutral90,
	ColorOrange100,
	ColorOrange200,
	ColorOrange300,
	ColorOrange400,
	ColorOrange500,
	ColorOrange600,
	ColorPurple100,
	ColorPurple200,
	ColorPurple300,
	ColorPurple400,
	ColorPurple500,
	ColorPurple600,
	ColorRed100,
	ColorRed200,
	ColorRed300,
	ColorRed400,
	ColorRed500,
	ColorRed600,
	ColorYellow100,
	ColorYellow200,
	ColorYellow300,
	ColorYellow400,
	ColorYellow500,
	ColorYellow600,
	Duration,
	DurationFast,
	DurationInstant,
	DurationSlow,
	FontFamilyBase,
	FontFamilyDisplay,
	FontLineHeightBase,
	FontLineHeightDisplay,
	FontSize100,
	FontSize200,
	FontSize300,
	FontSize400,
	FontSize500,
	FontSize600,
	FontSize700,
	FontSize800,
	FontSize900,
	FontWeightBold,
	FontWeightNormal,
	FontWeightSemibold,
	Radius0,
	Radius1,
	Radius2,
	Radius3,
	Radius4,
	Radius5,
	Radius6,
	Radius7,
	Radius8,
	Size0,
	Size1,
	Size10,
	Size11,
	Size12,
	Size13,
	Size14,
	Size2,
	Size3,
	Size4,
	Size5,
	Size6,
	Size7,
	Size8,
	Size9,
	SizeHalf,
	SizeQuarter,
	TransitionEase,
	TransitionEaseIn,
	TransitionEaseInOut,
	TransitionEaseOut
}, Symbol.toStringTag, { value: 'Module' }));

export { BreakpointSm as B, DurationSlow as D, BreakpointMd as a, BreakpointLg as b, BreakpointXl as c, BreakpointXxl as d, Duration as e, primitive as p };
//# sourceMappingURL=primitive-DEjVLxOV.js.map
